import * as d3 from 'd3'
export default {
  methods: {

    draw_Table(selection, chtData) {

      let tbl = this.table
      let st = this.timeline.styles

      tbl.y = 0
      this.gmx_Line(selection, 0, 0, 0, tbl.y, tbl.stroke.strong, .5, 1)
     
      if(st.year.visible == 'Y') {
        this.timeline.year.forEach(d=> {
          selection
          .append('text')
          .attr('transform', `translate(${d.mx}, ${tbl.y + st.year.height/2 + (st.year.tSize*0.36)})`)
          .attr('font-size', st.year.tSize).attr('fill', st.year.tColor).attr('text-anchor', 'middle')
          .text(d.name)

          this.gmx_Line(selection, d.ex, d.ex, tbl.y, tbl.y + st.year.height, tbl.stroke.medium, .5, 1)
        })
        
        tbl.y += st.year.height
        this.gmx_Line(selection, 0, this.chart.width, tbl.y, tbl.y, tbl.stroke.medium, .5, 1)
      }

      if(st.month.visible == 'Y') {
        this.timeline.month.forEach(d=> {
          selection
          .append('text')
          .attr('transform', `translate(${d.mx}, ${tbl.y + st.month.height/2 + (st.month.tSize*0.36)})`)
          .attr('font-size', st.month.tSize).attr('fill', st.month.tColor).attr('text-anchor', 'middle')
          .text(d.name)

          this.gmx_Line(selection, d.ex, d.ex, tbl.y, tbl.y + st.month.height, tbl.stroke.medium, .5, 1)
        })
        
        tbl.y += st.month.height
        this.gmx_Line(selection, 0, this.chart.width, tbl.y, tbl.y, tbl.stroke.medium, .5, 1)
      }

      if(st.week.visible == 'Y') {
        this.timeline.week.forEach(d=> {
          selection
          .append('text')
          .attr('transform', `translate(${d.mx}, ${tbl.y + st.week.height/2 + (st.week.tSize*0.36)})`)
          .attr('font-size', st.week.tSize).attr('fill', st.week.tColor).attr('text-anchor', 'middle')
          .text(d.name)

          this.gmx_Line(selection, d.ex, d.ex, tbl.y, tbl.y + st.week.height, tbl.stroke.medium, .5, 1)
        })
        tbl.y += st.week.height
      }
      


      // Data Table -----------------------------------------------------------------------------------------------
      let tblCanvas = selection
      .append('g')
      .attr('transform', `translate(${0}, ${0})`)

      this.gmx_Line(tblCanvas, tbl.x, this.chart.width, tbl.y, tbl.y, tbl.stroke.strong, .5, 1)
      this.gmx_Line(tblCanvas, tbl.x, tbl.x, tbl.y, tbl.y+tbl.height, tbl.stroke.strong, .5, 1)
     
      let x_ = 0
      chtData.forEach((d,i)=> {

        let y_ = tbl.y
        this.chart.styles.filter(f=> f.tbl == 'Y').forEach((col,c)=> {
          if(i==0) {
            let x_ = tbl.itemAlign=='middle' ? tbl.x/2 : tbl.itemAlign=='end' ? -5: tbl.x + 5
            
            tblCanvas
            .append('text')
            .attr('transform', `translate(${x_}, ${y_+ tbl.lineHeight/2 + (tbl.tSize*0.36)})`)
            .attr('font-size', tbl.tSize).attr('fill', tbl.tColor.item).attr('text-anchor', tbl.itemAlign)
            .text(col.name)
          }
          
          tblCanvas
          .append('text')
          .attr('transform', `translate(${d.mx}, ${y_+ tbl.lineHeight/2 + (tbl.tSize*0.36)})`)
          .attr('font-size', tbl.tSize)
          .attr('fill', ()=> {
            let color = tbl.tColor.val
            if(d.CDATE == this.timeline.cutoff.date) color = tbl.tColor.cutoff
            if(col.vColor == 'delta') color = this.gmx_deltaValue(d[col.code])
            return color
          })
          .attr('text-anchor', 'middle')
          .text(d[col.code])

          y_ += tbl.lineHeight
          this.gmx_Line(tblCanvas, tbl.x, this.chart.width, y_, y_, (y_==tbl.y+tbl.height) ? tbl.stroke.strong : tbl.stroke.medium, .5, 1)
        })

        this.gmx_Line(tblCanvas, this.timeline.week[i].sx, this.timeline.week[i].sx, (i==0) ? 0 : tbl.y, tbl.y+tbl.height, (i==0) ? tbl.stroke.strong : tbl.stroke.medium, .5, 1)
        x_ += d.mx
      
      })

      this.gmx_Line(tblCanvas, this.chart.width, this.chart.width, 0, tbl.y+tbl.height,  tbl.stroke.strong, .5, 1)
    },

  }
}
